import toast from "react-hot-toast";
import usePut from "../../usePut";

const useDeleteSalaryComponent = ({ onComponentDeleted }) => {
  const { handleAuth: deleteReq } = usePut({
    url: "salary-components/delete",
    refreshUrl: [
      "salary-components/list",
      "dashboard/company_completion_status",
      "is_permission_for_product",
    ],
    onSuccess: (data) => {
      toast.success("Salary component deleted successfully");
      if (onComponentDeleted) onComponentDeleted(data);
    },
    onError: (error) => {
      toast.error("Failed to delete salary component: " + error?.message);
    },
  });
  const isDeleting = deleteReq.isLoading;

  const deleteComponent = (componentId) => {
    deleteReq.mutate({ component_id: componentId });
  };

  return { deleteComponent, isDeleting };
};

export default useDeleteSalaryComponent;
